module.exports = __webpack_public_path__ + "img/mc.08e54354.svg";